// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__PVCc9","title":"styles_title__bKiu3","description":"styles_description__ov1mL","link":"styles_link__NkjTd"};